import React from "react";
import { Table } from "antd";
import { ActiveCheckbox, EditButton } from "../../common/TableCols";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const APRSubjectTable = ({ data, onEdited, onRowSelected }) => {
  const { t } = useTranslation();

  const APRLvl = (value) =>
    value === 0 ? <div>{t("aprLvlConfigForm.not_required")}</div> : value;

  const IsOverrideActiveCheckbox = (value) => (
    <ActiveCheckbox isChecked={value} />
  );
  const APRSubjectEditButton = (value) => (
    <EditButton fncEdit={() => onEdited(value)} />
  );
  data =
    data && data.length > 0
      ? data.map((record) => {
          return {
            ...record,
            L1Approvers: record.L1Approvers.join(", "),
            L2Approvers: record.L2Approvers.join(", "),
            Validators: record.Validators.join(", "),
          };
        })
      : [];
  const expandedRowRender = (result) => {
    const columns = [
      {
        title: t("aprLvlConfigForm.L1_approver"),
        dataIndex: "L1Approvers",
        key: "L1Approvers",
        width: 150,
      },
      {
        title: t("aprLvlConfigForm.L2_approver"),
        dataIndex: "L2Approvers",
        key: "L2Approvers",
        width: 150,
      },
    ];

    if (result.IsValidateTrans) {
      columns.push({
        title:
          result.Subject === "VEH" || result.Subject === "ROOM"
            ? t("aprLvlConfigForm.assignor")
            : t("aprLvlConfigForm.validator"),
        dataIndex: "Validators",
        key: "Validators",
        width: 150,
      });
    }

    return (
      <Table
        columns={columns}
        rowKey={(record) => record.APRConfgKey}
        dataSource={data.filter(
          (x) =>
            x.APRConfgKey === result.APRConfgKey &&
            x.SubjectKey === result.SubjectKey
        )}
        pagination={false}
      />
    );
  };

  const columns = [
    {
      title: t("aprLvlConfigForm.subject"),
      dataIndex: "Subject",
      key: "Subject",
    },
    {
      title: t("general.description"),
      dataIndex: "SubjectDesc",
      key: "SubjectDesc",
    },
    {
      title: t("aprLvlConfigForm.approval_level"),
      dataIndex: "SubjectAppLvl",
      key: "AppLvl",
      align: "right",
      render: APRLvl,
    },
    {
      title: t("aprLvlConfigForm.email_notification"),
      dataIndex: "EmailNotification",
      key: "EmailNotification",
      align: "center",
      width: 150,
      render: IsOverrideActiveCheckbox,
    },
    data && data.length > 0
      ? {
          title: t("general.action"),
          dataIndex: "Subject",
          key: "EditAPRSubject",
          align: "center",
          width: 50,
          render: APRSubjectEditButton,
        }
      : null,
  ];

  return (
    <div>
      <Table
        dataSource={data}
        columns={columns.filter((x) => x !== null)}
        expandedRowRender={expandedRowRender}
        size="small"
        pagination={false}
        rowKey={(record) =>
          record.APRConfgKey + record.SubjectKey + record.Subject
        }
        onRow={(r) => ({ onClick: () => onRowSelected(r) })}
      />
    </div>
  );
};

APRSubjectTable.propTypes = {
  data: PropTypes.array.isRequired,
  onEdited: PropTypes.func.isRequired,
  onRowSelected: PropTypes.func.isRequired,
};
